import request from '@/CommonDP/utils/request';
import env from '../utils/env';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  // 提资关联文件
  queryTzDocTree(params) {
    return request.post(`/doc/queryTzDocTree`, params);
  },
  // 我的提交 任务
  queryMySubmitListTask(params) {
    return request.post(`/prj-plan-task/queryMySubmitList`, params);
  },
  // 我的待处理 任务
  queryMyCurrentApproveListTask(params, pageSize, pageNum) {
    return request.post(
      `/prj-plan-task/queryMyCurrentApproveList?pageSize=${pageSize}&pageNo=${pageNum}`,
      params
    );
  },
  // 接收位置
  docList(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post('/doc/list', params).then((res) => res);
  },
  // 任务项目
  queryTaskPrjList(enterpriseId) {
    return request.get(
      `/prj-plan-task/queryTaskPrjList?enterpriseId=${enterpriseId}`
    );
  },
  // 上传文件
  uploadFile(params) {
    return request.post('/common/upload', params).then((res) => res);
  },
  // 下载本地文件
  download(filePath, token) {
    return (
      env.VUE_APP_API + `/download/${filePath}?token=${token}`
    );
  },
  // 根据固定文件夹id查询项目真实文件夹id
  queryByOldld(oldId, prjId) {
    return request.get(
      `/doc/folderId/getByOldId?oldId=${oldId}&prjId=${prjId}`
    );
  }
};
